import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    boxSizing: "border-box",
    gap: "16px",
    borderBottom: "none",
  },
  paper: {
    background: "#F9FAFA",
    boxShadow: "none",
    padding: theme.spacing(3, 2),
  },
  filters: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
  },
  filtersLeft: {
    display: "flex",
    alignItems: "flex-end",
    gap: 8,
  },
  filterBox: {
    display: "flex",
    gap: 8,
  },
  filtersRight: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
  },
  contentBox: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    margin: theme.spacing(0, 2),
    maxHeight: "calc(100vh - 210px)",
    overflow: "scroll",
  },
  graphSection: {
    borderRadius: 4,
    background: "#F9FAFA",
    padding: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },
  graphSectionContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  graphSectionTitle: {
    fontSize: 18,
  },
  graphStats: {
    marginTop: 24,
    display: "flex",
    justifyContent: "center",
    gap: 24,
  },
  graphStatsBox: {
    width: "33.3%",
    display: "flex",
    alignItems: "center",
    gap: 24,
    "&:first-child, &:nth-child(2)": {
      paddingRight: 24,
      borderRight: "1px #BEBFC0 solid",
    },
  },
  graphStatCounts: {
    display: "flex",
    flexDirection: "column",
  },
  graphStatCount: {
    fontSize: 32,
  },
  graphStatName: {
    fontSize: 18,
  },
  graphGraphBox: {
    width: "100%",
  },
  filterInputs: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  tableContainer: {
    scrollbarWidth: "none",
    display: "inline-block",
    width: "auto",
    maxWidth: "none",
    boxShadow: "none",
    borderRight: "1px solid #BEBFC0",
    maxHeight: "calc(100vh - 288px)",
    boxSizing: "border-box",
  },
  tableContainer2: {
    display: "inline-block",
    flex: 1,
    position: "relative",
    boxShadow: "none",
    borderTopRightRadius: 15,
    borderBottomRightRadius: 15,
    border: "none",
    maxHeight: "calc(100vh - 280px)",
    boxSizing: "border-box",
  },
  tableFooter: {
    borderTop: "1px solid #BEBFC0",
    width: "100%",
    height: 64,
    padding: theme.spacing(1, 0),
    position: "sticky",
    background: "#F9FAFA",
    zIndex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    bottom: 0,
  },
  tableHeadCell: {
    padding: "14px 0",
    background: "#F9FAFA",
    borderBottom: "1px solid #BEBFC0",
  },
  activeRow: {
    background: "#0129FA1A",
  },
  tableCell: {
    background: "#F9FAFA",
    padding: "14px 22px",
    textWrap: "nowrap",
    borderBottom: "1px solid #BEBFC0",
  },
  tableCellContent: {
    padding: "0 22px",
    borderLeft: "1px solid #E0E0E0",
  },
  editButton: {
    margin: "auto 0",
    color: "#0129FA",
    cursor: "pointer",
  },
  editButtonDisabled: {
    margin: "auto 0",
    color: "#0129FA",
  },
  editBox: {
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  fixedHeight: {
    height: 50,
  },
  settingsBtn: {
    borderColor: "#828487",
    padding: theme.spacing(0.9, 1),
    borderRadius: 5,
    "& .MuiButton-label": {
      display: "flex",
      gap: 8,
    },
    "& .MuiSvgIcon-root": {
      color: "#5F6164",
    },
  },
  editedMessage: {
    color: "#5F6164",
    fontWeight: 400,
  },
  drawerContent: {
    display: "flex",
    flexDirection: "column",
  },
  actionSection: {
    padding: theme.spacing(2, 3),
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    gap: theme.spacing(2),
  },
  actionButtons: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginLeft: "0 !important",
    gap: theme.spacing(1),
  },
  actionButtonsLeft: {
    display: "flex",
    gap: 8,
  },
  drawerButton: {},
  selectCheckbox: {
    "&.MuiCheckbox-colorSecondary.Mui-checked": {
      color: "#0129FA",
    },
    fill: "#5F6164",
  },
  formSection: {
    marginTop: theme.spacing(3),
  },
  textareaLabel: {
    color: "#5F6164",
    fontSize: 14,
    fontWeight: 400,
    margin: theme.spacing(0, 0, 0.5),
  },
  textarea: {
    height: 160,
    display: "flex",
    alignItems: "flex-start",
    width: "100%",
    boxSizing: "border-box",
  },
  "@media (max-width: 1340px)": {
    filters: {
      flexDirection: "column",
      gap: 16,
    },
    filtersLeft: {
      alignSelf: "flex-start",
    },
    contentBox: {
      maxHeight: "calc(100vh - 270px)",
    },
  },
  "@media (max-width: 840px)": {
    filters: {
      flexDirection: "column",
      gap: 16,
    },
    filtersLeft: {
      width: "100%",
      alignSelf: "flex-start",
      flexWrap: "wrap",
      flexDirection: "column",
    },
    filterBox: {
      width: "100%",
    },
    filterInputs: {
      alignItems: "flex-start",
      flexDirection: "column",
    },
    contentBox: {
      margin: theme.spacing(0),
    },
    graphSection: {
      borderRadius: 0,
    },
    graphStats: {
      flexDirection: "column",
    },
    graphStatsBox: {
      width: "100%",
      "&:first-child, &:nth-child(2)": {
        paddingRight: 0,
        paddingBottom: 24,
        borderRight: "none",
        borderBottom: "1px #BEBFC0 solid",
      },
    },
    graphSectionTitle: {
      display: "none",
    },
    fixedHeight: {
      height: 42,
    },
  },
}));
